(() => {
  "use strict";

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  function initMobileMenu() {
    const button = $("[data-mobile-menu]");
    const nav = $("[data-mobile-nav]");
    if (!button || !nav) return;

    const setOpen = open => {
      nav.classList.toggle("open", open);
      button.setAttribute("aria-expanded", String(open));
    };

    button.addEventListener("click", () => setOpen(!nav.classList.contains("open")));
    nav.addEventListener("click", event => {
      if (event.target.closest("a")) setOpen(false);
    });
    document.addEventListener("keydown", event => {
      if (event.key === "Escape") setOpen(false);
    });
  }

  function initProductGallery() {
    const gallery = $("[data-product-gallery]");
    const mainImage = $("[data-main-product-image]");
    if (!gallery || !mainImage) return;

    gallery.addEventListener("click", event => {
      const button = event.target.closest(".product-thumb");
      if (!button) return;

      const src = button.dataset.fullImage;
      if (!src) return;

      mainImage.removeAttribute("srcset");
      mainImage.removeAttribute("sizes");
      mainImage.src = src;
      mainImage.alt = button.dataset.alt || "";

      $$(".product-thumb", gallery).forEach(thumb => thumb.classList.remove("active"));
      button.classList.add("active");
    });
  }

  function inventoryLabel(option, labels) {
    const managed = Boolean(option.dataset.inventoryManagement);
    const quantity = Number.parseInt(option.dataset.inventoryQuantity || "0", 10);
    const policy = option.dataset.inventoryPolicy;
    const available = option.dataset.available === "true";

    if (managed) {
      if (quantity > 0) return labels.available;
      if (policy === "continue") return labels.madeToOrder;
      return labels.soldOut;
    }
    return available ? labels.available : labels.soldOut;
  }

  function initVariantInventory() {
    const select = $("[data-variant-select]");
    const status = $("[data-inventory-status]");
    const addButton = $("[data-add-to-cart]");
    const price = $("[data-product-price]");
    if (!select || !status) return;

    const labels = {
      available: status.dataset.labelAvailable || "Available",
      madeToOrder: status.dataset.labelMadeToOrder || "Made to order",
      soldOut: status.dataset.labelSoldOut || "Sold out"
    };

    const refresh = () => {
      const option = select.options[select.selectedIndex];
      const label = inventoryLabel(option, labels);

      status.innerHTML = `<span class="pill">${label}</span>`;

      if (price && option.dataset.price) {
        price.textContent = option.dataset.price;
      }

      if (addButton) {
        const soldOut = label === labels.soldOut;
        addButton.disabled = soldOut;
        addButton.textContent = soldOut
          ? (addButton.dataset.labelSoldOut || labels.soldOut)
          : (addButton.dataset.labelAdd || "Add to cart");
      }
    };

    select.addEventListener("change", refresh);
    refresh();
  }

  function initMailtoForm() {
    const form = $("[data-mailto-form]");
    const button = $("[data-open-mail]", form || document);
    if (!form || !button) return;

    button.addEventListener("click", () => {
      if (!form.reportValidity()) return;

      const data = new FormData(form);
      const value = name => String(data.get(name) || "").trim();
      const brand = value("brand");
      const model = value("model");

      const label = key => form.dataset[key] || "";
      const subject = [label("mailSubject"), brand, model].filter(Boolean).join(" - ");
      const body = [
        label("mailIntro"),
        "",
        label("mailName") + ": " + value("name"),
        label("mailEmail") + ": " + value("email"),
        label("mailBrand") + ": " + brand,
        label("mailModel") + ": " + model,
        label("mailYear") + ": " + value("year"),
        label("mailEngine") + ": " + (value("engine") || label("mailNotIndicatedF")),
        label("mailVersion") + ": " + (value("version") || label("mailNotIndicatedF")),
        label("mailCode") + ": " + (value("code") || label("mailNotIndicatedM")),
        "",
        label("mailDescription"),
        value("description"),
        "",
        label("mailAttachment")
      ].join("\n");

      window.location.href =
        "mailto:classicparts3d.shop@gmail.com" +
        "?subject=" + encodeURIComponent(subject) +
        "&body=" + encodeURIComponent(body);
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initMobileMenu();
    initProductGallery();
    initVariantInventory();
    initMailtoForm();
  });
})();